import { useAppSettingsStore } from '@/shared/lib';
import type { Theme } from '@/shared/types';
import { useEffect } from 'react';

const ThemeProvider = () => {
  const { theme, setTheme } = useAppSettingsStore();

  const applyTheme = (theme: Theme) => {
    const action = theme === 'dark' ? 'add' : 'remove';
    document.documentElement.classList[action]('dark');
  };

  useEffect(() => {
    if (theme) {
      setTheme(theme);
      return;
    }

    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    const systemTheme: Theme = prefersDark ? 'dark' : 'light';
    setTheme(systemTheme);
  }, []);

  useEffect(() => {
    if (theme) {
      applyTheme(theme);
    }
  }, [theme]);

  return null;
};

export { ThemeProvider };
